// Prerequisite checklist for a specific-output wizard entry: what a chosen
// deliverable needs, with done / pending(warn) / todo states per row. The
// page computes the states; this only renders. Reusable by future wizards.
//
// Props:
//   heading: string
//   items: [{ key, label, detail, state: 'done'|'warn'|'todo' }]
import React from 'react';
import { FONTS, INK, NEUTRAL, STATE, card } from '../utils/wizardTheme';

function DoneIcon() {
  return (
    <div style={{
      width: '24px', height: '24px', borderRadius: '8px', background: STATE.done.main,
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ffffff"
        strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </div>
  );
}

function WarnIcon() {
  return (
    <div style={{
      width: '24px', height: '24px', borderRadius: '8px', background: STATE.gate.tint,
      border: `1.5px solid ${STATE.gate.strong}`, boxSizing: 'border-box',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
    }}>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke={STATE.gate.main}
        strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="7" x2="12" y2="13" />
        <circle cx="12" cy="17" r="0.5" />
      </svg>
    </div>
  );
}

function TodoIcon() {
  return (
    <div style={{
      width: '24px', height: '24px', borderRadius: '8px', background: NEUTRAL.chipBg,
      border: `1.5px solid ${NEUTRAL.controlSoft}`, boxSizing: 'border-box', flexShrink: 0,
    }} />
  );
}

const ICONS = { done: DoneIcon, warn: WarnIcon, todo: TodoIcon };

export default function PrereqChecklist({ heading, items }) {
  return (
    <div style={{
      ...card, padding: '20px 22px',
      display: 'flex', flexDirection: 'column', gap: '15px',
    }}>
      <div style={{ fontFamily: FONTS.display, fontWeight: 600, fontSize: '15px' }}>{heading}</div>
      {items.map(it => {
        const Icon = ICONS[it.state] || TodoIcon;
        const labelColor = it.state === 'warn' ? STATE.gate.main : INK.body;
        const detailColor = it.state === 'warn' ? STATE.gate.text : INK.muted;
        return (
          <div key={it.key} style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
            <Icon />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              <div style={{
                fontSize: '13px', fontWeight: it.state === 'warn' ? 700 : 600, color: labelColor,
              }}>
                {it.label}
              </div>
              {it.detail && (
                <div style={{ fontSize: '12px', color: detailColor }}>{it.detail}</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
